import { render, staticRenderFns } from "./CmgMealBuilderItemSelectorCard.vue?vue&type=template&id=499d5215&scoped=true&lang=pug&"
import script from "./cmg-meal-builder-item-selector-card.ts?vue&type=script&lang=ts&"
export * from "./cmg-meal-builder-item-selector-card.ts?vue&type=script&lang=ts&"
import style0 from "./cmg-meal-builder-item-selector-card.scss?vue&type=style&index=0&id=499d5215&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499d5215",
  null
  
)

export default component.exports